import { Validator } from '@vista-digital/validator';
export const filmWatchlistButtonEventsValidatorSchema = {
    onAddFilmToWatchlistFailed: Validator.optional(Validator.fn()),
    onFilmAddedToWatchlist: Validator.optional(Validator.fn()),
    onFilmRemovedFromWatchlist: Validator.optional(Validator.fn())
};
export const filmWatchlistButtonEventsValidator = Validator.object(filmWatchlistButtonEventsValidatorSchema);
